module.exports = __webpack_public_path__ + "static/media/C7.94703a68.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/C7.png
// module id = 899
// module chunks = 0